import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getLocation } from '$utilities/location';
import { useLocale } from '$contexts/locale.jsx';
import Button from '$partials/ui/button';
import IconSearch from '$partials/icons/search';
import LocaleSelector from '$partials/global/locale-selector.jsx';
import MobileNavigation from '$partials/global/mobile-navigation.jsx';
import SearchDialog from './search-dialog';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

const Logo = ({
    title = 'Strava Stories'
}) => {
    return (
        <svg
            fill='none'
            style={{ height: '19.2px' }}
            viewBox='0 0 400 35'
            xmlns='http://www.w3.org/2000/svg'>
            <title>{title}</title>
            <path
                clipRule='evenodd'
                d='M94.874 33.3049L94.873 33.3034H104.271L110.044 21.6582L115.816 33.3034H127.236L110.042 -0.000244141L93.7218 31.6171L87.4556 22.4377C91.3246 20.5658 93.7363 17.3237 93.7363 12.6667V12.575C93.7363 9.28807 92.7354 6.91353 90.8237 4.99556C88.5933 2.75836 84.9981 1.34298 79.355 1.34298H63.7897V33.3049H74.4396V24.1727H76.715L82.7226 33.3049H94.874ZM160.548 -0.000244141L143.356 33.3034H154.776L160.549 21.6582L166.322 33.3034H177.741L160.548 -0.000244141ZM135.305 34.6138L152.496 1.31021H141.077L135.304 12.9554L129.531 1.31021H118.112L135.305 34.6138ZM79.0364 16.5475C81.5845 16.5475 83.1322 15.4061 83.1322 13.4429V13.3512C83.1322 11.2966 81.539 10.2921 79.0819 10.2921H74.4396V16.5475H79.0364ZM41.0145 10.3835H31.6395V1.343H61.0396V10.3835H51.6647V33.3049H41.0145V10.3835ZM5.68933 21.7072L-6.10352e-05 28.5105C4.05063 32.0725 9.87619 33.8984 16.3385 33.8984C24.895 33.8984 30.402 29.7889 30.402 23.0766V22.9856C30.402 16.5476 24.9405 14.173 16.794 12.6667C13.4259 12.0268 12.5612 11.4796 12.5612 10.6118V10.5205C12.5612 9.74429 13.2897 9.1964 14.8822 9.1964C17.8403 9.1964 21.4363 10.1552 24.4395 12.3467L29.6283 5.13291C25.9417 2.21048 21.3908 0.74908 15.2466 0.74908C6.46226 0.74908 1.72929 5.45251 1.72929 11.5249V11.6166C1.72929 18.3739 8.01031 20.4292 15.1553 21.8895C18.5688 22.5747 19.5697 23.0766 19.5697 23.9901V24.0818C19.5697 24.9489 18.7509 25.4507 16.8391 25.4507C13.1073 25.4507 9.14804 24.3557 5.68933 21.7072Z'
                fill='#FC5200'
                fillRule='evenodd'/>
            <path
                d='M199.431 32.27C196.353 32.27 194.517 30.704 194.247 27.824L195.723 27.572C195.975 29.804 197.163 30.866 199.449 30.866C201.195 30.866 202.347 30.056 202.347 28.832C202.347 27.554 201.501 26.852 198.873 26.024C195.867 25.034 194.859 24.152 194.859 22.46C194.859 20.498 196.515 19.13 198.891 19.13C201.267 19.13 203.049 20.552 203.463 22.802L202.005 23.108C201.609 21.434 200.511 20.534 198.873 20.534C197.343 20.534 196.335 21.29 196.335 22.46C196.335 23.432 197.055 23.954 199.359 24.674C202.635 25.736 203.823 26.834 203.823 28.814C203.823 30.866 202.041 32.27 199.431 32.27ZM210.079 32V20.804H206.155V19.4H215.497V20.804H211.573V32H210.079ZM223.323 32.27C220.137 32.27 218.013 29.642 218.013 25.7C218.013 21.758 220.137 19.13 223.323 19.13C226.509 19.13 228.633 21.758 228.633 25.7C228.633 29.642 226.509 32.27 223.323 32.27ZM223.323 30.866C225.681 30.866 227.139 28.886 227.139 25.7C227.139 22.514 225.681 20.534 223.323 20.534C220.965 20.534 219.507 22.514 219.507 25.7C219.507 28.886 220.965 30.866 223.323 30.866ZM238.42 26.78V26.816L241.192 32H239.446L236.782 26.888H234.262V32H232.786V19.4H237.376C240.004 19.4 241.57 20.804 241.57 23.126C241.57 25.124 240.4 26.456 238.42 26.78ZM234.262 25.484H237.25C239.104 25.484 240.076 24.674 240.076 23.126C240.076 21.596 239.122 20.804 237.25 20.804H234.262V25.484ZM245.555 32V19.4H247.031V32H245.555ZM251.925 32V19.4H259.485V20.804H253.401V24.836H258.981V26.168H253.401V30.596H259.485V32H251.925ZM268.081 32.27C265.003 32.27 263.167 30.704 262.897 27.824L264.373 27.572C264.625 29.804 265.813 30.866 268.099 30.866C269.845 30.866 270.997 30.056 270.997 28.832C270.997 27.554 270.151 26.852 267.523 26.024C264.517 25.034 263.509 24.152 263.509 22.46C263.509 20.498 265.165 19.13 267.541 19.13C269.917 19.13 271.699 20.552 272.113 22.802L270.655 23.108C270.259 21.434 269.161 20.534 267.523 20.534C265.993 20.534 264.985 21.29 264.985 22.46C264.985 23.432 265.705 23.954 268.009 24.674C271.285 25.736 272.473 26.834 272.473 28.814C272.473 30.866 270.691 32.27 268.081 32.27Z'
                fill='black'/>
        </svg>
    );
};

const Marker = ({
    colour = '#FC5200'
}) => {
    return (
        <svg
            className='inline'
            style={{ width: '8px', height: '8px' }}
            viewBox='0 0 8 8'
            xmlns='http://www.w3.org/2000/svg'>
            <circle
                cx='4'
                cy='4'
                fill={colour}
                r='4' />
        </svg>
    );
};

const DesktopLink = ({
    invertTextColour,
    label,
    typename,
    url: originalURL,
}) => {
    const { formatURI } = useLocale();

    const location = getLocation()?.href?.replace(/\/$/, '');

    let url;
    if (typename === 'BvaMagazineAwardsNomineesPage') {
        url = formatURI(`/year-in-sport/${originalURL}/nominees`);
    } else if (typename === 'BvaMagazineAwardsLandingPage') {
        url = formatURI(`/year-in-sport/${originalURL}/winners`);
    } else {
        url = formatURI(`/${originalURL}`);
    }

    let isCurrent = false;

    if (originalURL === '/') {
        isCurrent = (url === location || location.startsWith(formatURI('/articles')));
    } else {
        isCurrent = location?.startsWith(url);
    }

    return (
        <>
            <a
                className=' type-style-7'
                href={url}>
                {label}
            </a>

            {isCurrent &&
                <div className='absolute left-0 right-0 mt-5'>
                    <Marker colour={invertTextColour ? '#fff' : '#FC5200'} />
                </div>
            }

            {!isCurrent &&
                <div className='absolute left-0 right-0 mt-5 invisible group-hover:visible'>
                    <Marker colour={invertTextColour ? '#fff' : '#000'} />
                </div>
            }
        </>
    );
};

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Header = ({
    invertTextColour,
    menu,
    search,
    title
}) => {
    const {
        formatURI,
        translate: t,
        options: localeOptions,
        current: locale
    } = useLocale();

    const [ searchOpen, setSearchOpen ] = useState(false);

    if (!menu) { return null; }

    return (
        <header className={`w-full pt-60 md:pt-80 flex type-style-7 px-10 sm:px-20${invertTextColour ? ' text-white' : ''}`}>
            <div className='flex-none w-150 mt-2'>
                <a href={formatURI('/')}>
                    <Logo title={title ?? undefined} />
                </a>
            </div>

            <div className='md:hidden flex-grow text-right'>
                <MobileNavigation
                    menu={menu}
                    search={search}/>
            </div>

            {menu.navigationLinks.items.length > 0 && (
                <nav className='hidden md:block flex-auto text-center self-end'>
                    <ul className='list-none inline-flex items-center'>
                        {menu.navigationLinks.items.map((navLink, idx) => (
                            <li
                                className='group mx-15 relative'
                                key={idx}>
                                <DesktopLink
                                    invertTextColour={invertTextColour}
                                    label={navLink.title}
                                    typename={navLink.__typename}
                                    url={navLink.slug} />
                            </li>
                        ))}
                    </ul>
                </nav>
            )}

            <SearchDialog
                closeModal={setSearchOpen}
                isModalOpen={searchOpen}
                keywords={search?.keywords}
                tags={search?.trending}/>

            <nav className='hidden md:block flex-none w-[190px] uppercase text-orange text-right self-end'>
                <Button
                    className='inline-flex mr-40 align-middle'
                    onClick={() => setSearchOpen(!searchOpen)}
                    renderIcon={<IconSearch stroke='#FC5200'/>}
                    type='button' />

                <LocaleSelector />

                <a
                    className='ml-15'
                    href='https://strava.app.link/N9u5AndPPMb'
                    rel='noreferrer'
                    target='_blank'>
                    {t('Sign up')}
                </a>
            </nav>
        </header>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

Header.propTypes = {
    invertTextColour: PropTypes.bool,
    menu: PropTypes.shape({
        navigationLinks: PropTypes.object,
    }),
    search: PropTypes.shape({
        keywords: PropTypes.array,
        trending: PropTypes.array,
    }),
    title: PropTypes.string
};

Logo.propTypes = {
    title: PropTypes.string
};

Marker.propTypes = {
    colour: PropTypes.string
};

DesktopLink.propTypes = {
    invertTextColour: PropTypes.bool,
    label: PropTypes.string,
    typename: PropTypes.string,
    url: PropTypes.string,
};

export default Header;
